module.exports = __webpack_public_path__ + "img/mm5.6385fc64.png";